import React, { type FunctionComponent } from 'react'
import { MenuOption } from './MenuOption'

interface Props {
  tag: string
  label: string
  subLabel?: string
}

export const UserOption: FunctionComponent<Props> = ({ children, tag, label, subLabel }) => (
  <MenuOption tagType={tag} label={label} subLabel={subLabel} showCircleLogo={false} />
)
